<script setup>

import { inject, watch, onMounted } from 'vue';

import { trouverCelluleTableau } from '@/scripts/navigationRapport.js'

import Cellule from './Cellule.vue'

const { tableau } = defineProps({
	tableau: Object
})

const selectionnerElement = inject('selectionnerElement');
const affichageElementsMasques = inject('affichageElementsMasques');

onMounted(() => {
	recalculerDecalagesBloc();
});

watch(() => tableau.selectionPremierElement, (sel) => {
	if (sel) {
		delete tableau.selectionPremierElement;
		let coordCellule = {ligne: 1, colonne: 1};
		let cellule;
		do {
			cellule = trouverCelluleTableau(tableau, coordCellule);
			if (!affichageElementsMasques.value && cellule?.masque) {
				if (tableau.expressionsEnColonnes) {
					if (coordCellule.colonne < tableau.nbColonnes) {
						coordCellule.colonne++;
					} else if (coordCellule.ligne < tableau.nbLignes) {
						coordCellule.colonne = 1;
						coordCellule.ligne++;
					} else {
						coordCellule = null;
					}
				} else {
					if (coordCellule.ligne < tableau.nbLignes) {
						coordCellule.ligne++;
					} else if (coordCellule.colonne < tableau.nbColonnes) {
						coordCellule.ligne = 1;
						coordCellule.colonne++;
					} else {
						coordCellule = null;
					}
				}
			} else {
				coordCellule = null;
			}

		} while (coordCellule !== null);
		if (cellule !== null) {
			selectionnerElement(cellule, tableau);
		}
	}
});

watch(() => tableau.recalculDecalagesBlocObjets, (indiceBloc) => {
	if (indiceBloc >= 0) {
		delete tableau.recalculDecalagesBlocObjets;
		recalculerDecalagesBlocObjets(indiceBloc);
	}
});

watch(() => tableau.recalculDecalagesBlocExpressions, (position) => {
	if (position) {
		delete tableau.recalculDecalagesBlocExpressions;
		recalculerDecalagesBlocExpressions(position[0], position[1]);
	}
});

watch(() => tableau, () => {
	recalculerDecalagesBloc();
});

watch(() => affichageElementsMasques.value, () => {
	recalculerDecalagesBloc();
});

watch(() => tableau.expressionsEnColonnes, () => {
	recalculerDecalagesBloc();
});

function recalculerDecalagesBloc() {
	for (const indiceBlocObjets in tableau.blocsEntetesObjets) {
		recalculerDecalagesBlocObjets(indiceBlocObjets);
		for (const indiceBlocExpressions in tableau.blocsEntetesObjets[indiceBlocObjets].blocsEntetesExpressions) {
			recalculerDecalagesBlocExpressions(indiceBlocObjets, indiceBlocExpressions);
		}
	}
}

function recalculerDecalagesBlocObjets(indiceBloc) {
	const attributPosition = (tableau.expressionsEnColonnes ? 'ligne' : 'colonne');
	const attributMarge = (tableau.expressionsEnColonnes ? 'margeHaut' : 'margeGauche');
	const premiereLigneColonneAffichee = Math.min(...tableau.cellules.filter(c => c.position[0] == indiceBloc && (affichageElementsMasques.value || !c.masque)).map(c => c[attributPosition]));
	const decalageBloc = tableau.blocsEntetesObjets[indiceBloc].decalage;
	tableau.cellules.filter(c => c.position[0] == indiceBloc).forEach(c => {
		if (c[attributPosition] == premiereLigneColonneAffichee) {
			c[attributMarge] = decalageBloc;
		} else {
			delete c[attributMarge];
		}
	});
}

function recalculerDecalagesBlocExpressions(indiceBlocObjets, indiceBlocExpressions) {
	const attributPosition = (tableau.expressionsEnColonnes ? 'colonne' : 'ligne');
	const attributMarge = (tableau.expressionsEnColonnes ? 'margeGauche' : 'margeHaut');
	const premiereLigneColonneAffichee = Math.min(...tableau.cellules.filter(c => c.position[0] == indiceBlocObjets && c.position[1] == indiceBlocExpressions && (affichageElementsMasques.value || !c.masque)).map(c => c[attributPosition]));
	const decalageBloc = tableau.blocsEntetesObjets[indiceBlocObjets].blocsEntetesExpressions[indiceBlocExpressions].decalage;
	tableau.cellules.filter(c => c.position[0] == indiceBlocObjets && c.position[1] == indiceBlocExpressions).forEach(c => {
		if (c[attributPosition] == premiereLigneColonneAffichee) {
			c[attributMarge] = decalageBloc;
		} else {
			delete c[attributMarge];
		}
	});
}

</script>

<template>
	<div class="tableau" :style="[tableau.style, {'grid-template-columns': `repeat(${tableau.nbColonnes}, auto)`}]" >
		<Cellule v-for="element in tableau.cellules" :tableau="tableau" :element="element" />
	</div>
</template>

<style scoped>

.tableau {
	display: grid;
	grid-gap:0px;
	justify-content: strech;
	justify-items: strech;
}

</style>